export default __webpack_public_path__ + "static/media/home.5d53cdda.svg";